/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { xliffToJson } from './xliff-to-json';
import { loadTranslations } from '@angular/localize';
import { registerLocaleData } from '@angular/common';
import { appLanguage } from './app/services/format-datepicker';

import(
  './../node_modules/wikipedia-preview/dist/wikipedia-preview.umd.cjs'
).then(() => {
  console.log('Wikipedia Preview script loaded');
});

if (environment.production) {
  enableProdMode();
}

const appLang = appLanguage();

initLanguage(appLang)
  // Beide Zweige warten inzwischen auf einen dynamischen Import. Faellt der aus — ein
  // nach dem Deploy noch gecachtes index.html zeigt auf alte Chunk-Hashes —, bliebe
  // ohne Auffangen eine weisse Seite. Lieber unlokalisierte Pipes als keine App.
  .catch((error: unknown) => console.error('Locale konnte nicht geladen werden', error))
  .then(() => import('./app/app.component'))
  .then((comp) => bootstrapApplication(comp.AppComponent, appConfig));

async function initLanguage(locale: string): Promise<void> {
  if (locale === 'de') {
    const deModule = await import('../node_modules/@angular/common/locales/de');
    registerLocaleData(deModule.default);
    return;
  }

  const json = await fetch('/locale/messages.' + locale + '.xlf')
    .then((r) => r.text())
    .then((t) => xliffToJson(t));

  loadTranslations(json);
  $localize.locale = locale;

  const localeModule = await import(
    `../node_modules/@angular/common/locales/en-GB`
  );
  registerLocaleData(localeModule.default);
}
